import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=0c057964&scoped=true"
var script = {}
import style0 from "./fullscreen.vue?vue&type=style&index=0&id=0c057964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c057964",
  null
  
)

export default component.exports